import { useMutation } from "@apollo/client";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SubmitButton from "../../../../components/common/SubmitButton";
import CustomFormGroup from "../../../../components/form/CustomFormGroup";
import {
  CREATE_ROOM,
  UPDATE_ROOM,
} from "../../../../graphql/mutations/management";
import { FETCH_ROOMS } from "../../../../graphql/queries/management";
import {
  clearRoomForm,
  onChangeRoomForm,
  toggleRoomModal,
  toggleSwitch,
} from "../../redux/roomSlice";
import CustomSwitch from "../../../../components/form/CustomSwitch";
import { ROOM_SWITCH_TYPES } from "../../redux/types";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/common/CustomErrorMessage";

const RoomForm = () => {
  const dispatch = useDispatch();
  const { createForm, updateForm, isEdit } = useSelector((state) => state.room);

  const [createRoom, { loading }] = useMutation(CREATE_ROOM, {
    refetchQueries: [{ query: FETCH_ROOMS }],
    onCompleted: (data) => {
      if (data.createRoom) {
        dispatch(toggleRoomModal());
        showSuccessToast();
        dispatch(clearRoomForm());
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const [updateRoom, { loading: updateLoading }] = useMutation(UPDATE_ROOM, {
    refetchQueries: [{ query: FETCH_ROOMS }],
    onCompleted: ({ updateRoom }) => {
      if (updateRoom) {
        dispatch(toggleRoomModal());
        showSuccessToast();
        dispatch(clearRoomForm());
      }
    },
    onError(err) {
      showErrorToast(err.message);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    isEdit
      ? updateRoom({
          variables: {
            id: updateForm.id,
            input: {
              name: updateForm.name,
              engName: updateForm.engName,
              isRequirePassword: updateForm.isRequirePassword,
              password: updateForm.password,
              isRequireMinimumBalance: updateForm.isRequireMinimumBalance,
              minimumBalance: updateForm.minimumBalance,
            },
          },
        })
      : createRoom({
          variables: {
            input: createForm,
          },
        });
  };

  const handleChange = (e) => {
    if (isEdit) {
      dispatch(
        onChangeRoomForm({
          ...updateForm,
          [e.target.name]:
            e.target.type === "number"
              ? parseInt(e.target.value)
              : e.target.value,
        })
      );
    } else {
      dispatch(
        onChangeRoomForm({
          ...createForm,
          [e.target.name]:
            e.target.type === "number"
              ? parseInt(e.target.value)
              : e.target.value,
        })
      );
    }
  };

  const togglePasswordSwitch = () =>
    dispatch(toggleSwitch({ type: ROOM_SWITCH_TYPES.PASSWORD }));

  const toggleBalanceSwitch = () =>
    dispatch(toggleSwitch({ type: ROOM_SWITCH_TYPES.MINIMUM_BALANCE }));

  const isLoading = isEdit ? updateLoading : loading;

  return (
    <Form className="notolao" onSubmit={handleSubmit}>
      <CustomFormGroup
        label="ຊື່ຫ້ອງ"
        name="name"
        onChange={handleChange}
        type="text"
        value={isEdit ? updateForm.name : createForm?.name}
        errorParam="name"
        required={true}
      />
      <CustomFormGroup
        label="ຊື່ຫ້ອງພາສາອັງກິດ"
        name="engName"
        onChange={handleChange}
        type="text"
        value={isEdit ? updateForm.engName : createForm.engName}
        errorParam="engName"
        required={true}
      />
      <CustomSwitch
        label="ຕ້ອງໃສ່ລະຫັດຜ່ານ"
        name="isRequirePassword"
        onChange={togglePasswordSwitch}
        value={
          isEdit ? updateForm.isRequirePassword : createForm?.isRequirePassword
        }
      />
      <CustomFormGroup
        label="ລະຫັດຜ່ານ"
        name="password"
        onChange={handleChange}
        type="text"
        value={isEdit ? updateForm.password : createForm?.password}
        errorParam="password"
        required={true}
      />
      <CustomSwitch
        label="ຕ້ອງການຍອດເງິນຂັ້ນຕ່ຳ"
        onChange={toggleBalanceSwitch}
        labelSize={3}
        inputSize={9}
        value={
          isEdit
            ? updateForm.isRequireMinimumBalance
            : createForm?.isRequireMinimumBalance
        }
      />
      <CustomFormGroup
        label="ຍອດເງິນຂັ້ນຕ່ຳ"
        name="minimumBalance"
        onChange={handleChange}
        type="number"
        value={isEdit ? updateForm.minimumBalance : createForm?.minimumBalance}
        errorParam="minimumBalance"
        required={true}
      />
      <div className="text-center">
        <SubmitButton loading={isLoading} />
      </div>
    </Form>
  );
};

export default RoomForm;
